<template>
  <div class="role-add-user">
    <el-button
      v-if="added"
      type="danger"
      icon="el-icon-delete"
      size="mini"
      :loading="loading"
      @click="doDel"
      >删除</el-button
    >
    <el-button
      v-else
      type="primary"
      icon="el-icon-plus"
      size="mini"
      :loading="loading"
      @click="doAdd"
      >添加</el-button
    >
  </div>
</template>
<script>
export default {
  name: 'role-add-user',
  props: {
    scope: Object,
    add: Function,
    del: Function
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    added() {
      return this.scope.row.added == true
    }
  },
  methods: {
    async doAdd() {
      if (typeof this.add !== 'function') {
        console.error('add 函数不存在')
        return
      }
      this.loading = true
      try {
        await this.add(this.scope.row)
      } catch (error) {
        console.error('添加用户失败:', error)
      } finally {
        this.loading = false
      }
    },
    async doDel() {
      if (typeof this.del !== 'function') {
        console.error('del 函数不存在')
        return
      }
      this.loading = true
      try {
        await this.del(this.scope.row)
      } catch (error) {
        console.error('删除用户失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
